<template lang="pug">
	div.mt-4.mb-6
		sfc-dynamic-tab-v3(:tabs="tabs")
			div(slot="0")
				div.alert.alert-success(class="alert alert-success" v-if="emailSucces")
					| The email has been changed.
				div.alert.alert-danger(class="alert alert-danger" v-if="errorServerEmail")
					a(@click="login()") Please log in again
				label
				label
					| Email address
				sfc-input(v-model="email" type="email"  :error="(this.emailError)" :error-message="emailErrorMessage" :flat="false" @input="isValidEmail()")
				
				sfc-button(text="UPDATE EMAIL" :blue="true"  @click="updateEmail()" :loading="loading")
			div(slot="1")
				div(class="alert alert-success" v-if="passwordNewSuccess")
					| The password has been changed.
				div.alert.alert-danger(class="alert alert-danger" v-if="errorServer")
					a(@click="login()") Please log in again
				label
					| Current Password
				sfc-input(v-model="password" type="password" :error="(this.passwordError)" :error-message="passwordErrorMessage" inputmode="password" :flat="false" @input="isValidPassword()" )
				br
				label
					| New Password
				sfc-input(v-model="newPassword" type="password" :error="(this.passwordNewError)" :error-message="passwordNewErrorMessage" inputmode="password" :flat="false" @input="isValidPasswordNew()" )
				br
				label
					| Confirm New Password
				sfc-input(v-model="confirmNewPassword" type="password" :error="(this.passwordNewErrorConfirm)" :error-message="passwordNewErrorMessageConfirm" inputmode="password" :flat="false" @input="isValidPasswordNewConfirm()" )
				sfc-button(text="UPDATE PASSWORD" :blue="true" @click="updatePassword()"  :loading="loadingButtonPassword")

</template>

<script>

import SfcButton from '@/common/components/sfc-button'
import UMFunctions from "@/lib/primary_functions.js"
import SfcDynamicTabV3 from '@/common/components/v3/sfc-dynamic-tab'
import SfcInputV2 from '@/common/components/inputs/v2/textbox'
import SfcInput from '@/common/components/inputs/v2/textbox'
import SfcTrackingService from "@/lib/sfc-tracking-service"

export default {

	props: {
		forceMobile: {
			default: false
		}
	},
	components:{
		SfcButton,
		SfcInput,
		SfcDynamicTabV3
	},

	data() { 
		return {
			tabs: ["Email address", "Password"],
			emailError: false,
			emailErrorMessage: null,
			passwordError: false,
			passwordNewError: false,
			passwordNewErrorConfirm: false,
			passwordNewSuccess:false,
			passwordErrorMessage: null,
			passwordNewErrorMessage: '',
			passwordNewErrorMessageConfirm:'',
			email: 'email@gmail.com',
			activeTab:0,
			password: '',
			showPassword: false,
			loading: false,
			loadingButtonPassword: false,
			validateOnChange: false,
			validateOnChangePswd: false,
			token:this.$cookies.get("sfc_primary"),
			emailSucces: false,
			errorServer:false,
			errorServerEmail:false,
			newPassword: '',
			confirmNewPassword: ''
		}
	},

	computed: {
		inputType(){
			if(this.showPassword){
				return "text"
			}else{
				return "password"
			}
		},
	},
	mounted(){
		this.email = this.$store.state.userEmail
		this.$root.$on('nextStepChange', this.objCopyChange)
	},

	methods: {
		setActiveTab(index){
			this.activeTab = index
		},
		isValidEmail(){
			let valueToReturn = true
			this.emailSucces= false
			if(this.validateOnChange){
				this.emailError = false
				this.loading=false
				this.passwordError = false
				const emailRegex = /^(([^<>()\[\]\\.,;:\s@“]+(\.[^<>()\[\]\\.,;:\s@“]+)*)|(“.+“))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
				if (!emailRegex.test(this.email)) {
					valueToReturn = false
					this.emailError = true
					this.emailErrorMessage = "Please enter a valid email"
					this.emailSucces=false
				}
				
			}
			return valueToReturn
		},
		isValidPassword(){
			let valueToReturn = true
			this.passwordNewSuccess= false
			this.passwordError = false
				if (!this.password || this.password.trim() == "") {
					this.passwordError = true
					this.passwordErrorMessage = 'Please enter a password'
				}
				if(!this.password){
					this.passwordError = true
					this.passwordErrorMessage = 'Invalid password'
				}
			
		},
		isValidPasswordNew(){
				let valueToReturn = true
				this.passwordNewSuccess= false
				if (!this.newPassword || this.newPassword.trim() == "") {
					valueToReturn = false
					this.passwordNewError=true
					this.passwordNewErrorMessage="Invalid new password"
					}else{
				if(!this.newPassword || this.newPassword.trim().length < 8){
					valueToReturn = false
					this.passwordNewError = true
					this.passwordNewErrorMessage = 'Please enter a password with 8 characters or more'
					}else{
					this.passwordNewError = false
					}
				}
				if(this.newPassword==this.confirmNewPassword){
						this.passwordNewErrorConfirm=false
					}else{
						this.passwordNewErrorConfirm=true
						this.passwordNewErrorMessageConfirm='Password confirmation doesn’t match'
					}
			return valueToReturn;
		},
		isValidPasswordNewConfirm(){
			let valueToReturn = true
			if ((this.newPassword == this.confirmNewPassword))
			{
				this.passwordNewErrorConfirm=false
			}else{
				valueToReturn = false
				this.passwordNewErrorConfirm=true
				this.passwordNewErrorMessageConfirm='Password confirmation doesn’t match'
			}
			return valueToReturn;
		},
		async updateEmail(){
			this.validateOnChange = true
			this.emailSucces= false
			if(!this.isValidEmail())	return
				this.loading=true
			try{
				let serverUrl = `${this.$store.state.config.userManagementHost}/securelogins/api/v1`
				let params = {
				app_id: 5,
				email:this.email,
				token: this.token
				}
				let result = await this.$httpService.post(`${serverUrl}/change_email`, params)
				this.loading=true
				if(!result.success){
					this.valueToReturn = false
					this.emailError = true
					this.emailErrorMessage = (result.message == 'Changing email > Email already exists' ) ? 'Email already exists' : 'Invalid email'
					this.emailSucces=false
					this.loading=false
				}else{
					this.emailSucces=true
					this.loading=false
				}

			}
			catch(err){
				this.valueToReturn = false
				this.emailError = true
				this.loading=false
				this.errorServerEmail=true
				this.emailErrorMessage= "response server error"

			}

		},
		
		async updatePassword(){
			this.loadingButtonPassword=true
			this.passwordNewSuccess= false
			if(!this.passwordError && (this.newPassword == this.confirmNewPassword) && !this.passwordNewError &&  this.newPassword != ""){
				try{
				let serverUrl = `${this.$store.state.config.userManagementHost}/securelogins/api/v1`
				let params = {
				app_id: 5,
				old_password:this.password,
				password:this.newPassword,
				token: this.token
				}
				let result = await this.$httpService.post(`${serverUrl}/change_password`, params)
				if(result.success){
					this.passwordNewSuccess= true
					this.errorServer=false
					this.passwordNewError=false
					this.passwordNewErrorConfirm=false
					this.passwordNewError=false	
					this.passwordError=false
				}else{
					if(result.message!='Changing password > token is invalid'){
					this.valueToReturn = false
					this.passwordErrorMessage='Invalid current password'
					this.passwordError=true
					this.passwordNewSuccess= false
					this.loadingButtonPassword=false
				}else{
						this.loadingButtonPassword=false
						this.valueToReturn = true
						this.errorServer=true
					}
				}
				this.loadingButtonPassword=false
			}
			catch(err){
				this.valueToReturn = false
				this.loadingButtonPassword=false
				;
			}
				}
				else{
					if(this.passwordNewError== true ){
						this.passwordNewErrorMessage='Please enter the current password'
					}
					if(!this.newPassword){
						this.isValidPasswordNew()
					}
					if(!this.password){
						this.isValidPassword()
					}
					if(this.passwordNewErrorConfirm== true){
						this.passwordNewErrorMessageConfirm='Password confirmation doesn’t match'
					}
					this.loadingButtonPassword=false
					return false
				}
		},
		login(){
			return window.location.href ="/savings-center/login"
		}
	}
}
</script>